import { Routes, Route } from 'react-router-dom';
import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
// Dashboard
import Dashboard from '../../_modules/admin/dashboard/Dashboard';
// Product
import Product from '../../_modules/admin/products/Product';
import AddProduct from '../../_modules/admin/products/AddProduct';
import EditProduct from '../../_modules/admin/products/EditProduct';
import ProductDetail from '../../_modules/admin/products/ProductDetail';

import NewsletterForm from '../../_modules/admin/newsletters/NewsletterForm';
import OrderDetail from '../../_modules/admin/orders/OrderDetail';
import Orders from '../../_modules/admin/orders/Orders';

function Master() {
  const company = 'Mipat SPILLCLEAN& - Natural Spill Absorbent';

  useEffect(() => {
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = false; // ensure sequential loading
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });

    (async () => {
      // --- Load WebFont first ---
      await loadScript("/_admin/assets/js/plugin/webfont/webfont.min.js");

      // --- Then initialize fonts ---
      if (window.WebFont) {
        window.WebFont.load({
          google: { families: ["Public Sans:300,400,500,600,700"] },
          custom: {
            families: [
              "Font Awesome 5 Solid",
              "Font Awesome 5 Regular",
              "Font Awesome 5 Brands",
              "simple-line-icons",
            ],
            urls: ["/_admin/assets/css/fonts.min.css"],
          },
          active: function () {
            sessionStorage.fonts = true;
          },
        });
      }

      await loadScript("/_admin/assets/js/core/jquery-3.7.1.min.js");
      await loadScript("/_admin/assets/js/core/popper.min.js");
      await loadScript("/_admin/assets/js/core/bootstrap.min.js");
      await loadScript("/_admin/assets/js/plugin/jquery-scrollbar/jquery.scrollbar.min.js");
      await loadScript("/_admin/assets/js/plugin/chart.js/chart.min.js");
      await loadScript("/_admin/assets/js/plugin/jquery.sparkline/jquery.sparkline.min.js");
      await loadScript("/_admin/assets/js/plugin/chart-circle/circles.min.js");
      await loadScript("/_admin/assets/js/plugin/datatables/datatables.min.js");
      await loadScript("/_admin/assets/js/plugin/bootstrap-notify/bootstrap-notify.min.js");
      await loadScript("/_admin/assets/js/plugin/jsvectormap/jsvectormap.min.js");
      await loadScript("/_admin/assets/js/plugin/jsvectormap/world.js");
      await loadScript("/_admin/assets/js/plugin/sweetalert/sweetalert.min.js");
      await loadScript("/_admin/assets/js/kaiadmin.min.js");
    })();
  }, []);

  return (
    <>
    <Helmet>
      <link rel="stylesheet" href="/_admin/assets/css/bootstrap.min.css" />
      <link rel="stylesheet" href="/_admin/assets/css/plugins.min.css" />
      <link rel="stylesheet" href="/_admin/assets/css/kaiadmin.min.css" />
    </Helmet>

    <Routes>
      <Route path="/dashboard" element={<Dashboard page="Dashboard" company={company} />} />
      
      {/* PRODUCT */}
      <Route path="/add-product" element={
        <AddProduct page="Add Product" btnManage="Browse Products" company={company} />
      } />
      <Route path="/product" element={
        <Product page="Browse Products" btnAdd="Add Product" company={company} />
      } />
      <Route path="/edit-product/:slug" element={
        <EditProduct page="Edit Product" btnBack="Back" company={company} />
      } />
      <Route path="/product-detail/:slug" element={
        <ProductDetail page="Product Detail" btnBack="Back" company={company} />}
      />

      {/* ORDERS */}
      <Route path="/orders" element={
        <Orders page="Orders" btnBack="Back" company={company} />
      } />

      <Route path="/orderdetail/:id" 
        element={<OrderDetail btnBack="Back" company={company} />
      } />

      {/* NEWSLETTER */}
      <Route path="/newsletter" element={
        <NewsletterForm page="Send Newsletter" btnBack="Back" company={company} />
      } />
 
    </Routes>
    </>
  );
}

export default Master;